import type { BlockProps } from '../types.js'
import { SectionWrapper } from './SectionWrapper.js'
import { GREETING_FONT_SIZE_MAP } from './formatters.js'
import common from './common.module.css'

interface GreetingBlockProps extends BlockProps {
  layout?: 'centered' | 'framed'
  css: Record<string, string>
}

export function GreetingBlock({ invitation, activeSection, onSectionClick, mode, css }: GreetingBlockProps) {
  const greeting = invitation.content?.greeting
  const greetingFontSize = invitation.content?.greetingFontSize ?? 'md'
  const greetingFontSizePx = greetingFontSize === 'custom'
    ? (invitation.content?.greetingFontSizeCustom ?? 12)
    : (GREETING_FONT_SIZE_MAP[greetingFontSize] ?? 12)

  return (
    <SectionWrapper
      sectionId="greeting"
      activeSection={activeSection}
      onSectionClick={onSectionClick}
      mode={mode}
      className={common.section}
    >
      <span className={common.sectionTitle}>인사말</span>
      <div className={common.divider} />
      <p className={css.greetingText} style={{ fontSize: `${greetingFontSizePx}px` }}>
        {greeting || '소중한 분들을 초대합니다.\n저희 두 사람이 사랑의 이름으로\n하나가 되려 합니다.'}
      </p>
    </SectionWrapper>
  )
}
